import React from 'react'
import {AppBar, Grid, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types'
import clsx from 'clsx';
import AuditBarTitle from './AuditBarTitle';
import {connect} from 'react-redux'

const style = theme => ({
	root: {
		borderBottom: `solid 1px ${theme.palette.primary.main}`,
		width: 'unset',
		padding: theme.spacing(1),
		paddingLeft: theme.spacing(4),
		minHeight: theme.mixins.toolbar.minHeight + theme.spacing(2),
		backgroundColor: theme.palette.background.greyBackground,
	},
	open: {
		maxHeight: 500,
		transition: theme.transitions.default.open('max-height'),
		'& $content': {
			margin: `${theme.spacing(1)}px 0`,
			padding: `${theme.spacing(1)}px 0`
		}
	},
	close: {
		maxHeight: 0,
		overflow: 'hidden',
		transition: theme.transitions.default.close('max-height'),
		'& $content': {
			height: 0,
			opacity: 0,
			zIndex: -1,
			marginTop: theme.spacing(-1)
		},
	},
	content: {
		borderColor: theme.palette.primary.contrastText,
		borderStyle: 'solid',
		borderWidth: '1px 0',
	},
	title: {
		width: "100%"
	},
	infoContainer: {
		'&>*': {
			flexGrow: 1,
			flexShrink: 0,
			flexBasis: 0,
		}
	},
})

function AuditBar({
	auditTask,
	classes
}) {

	return (
		<>
			<AppBar
				id='appBar'
				className={clsx(
					classes.root,
					classes.close
				)}
				component='div'
				elevation={0}
				position='relative'
			>
				<Grid
					container
					direction='column'
				>
					<Grid item className={classes.title}>
						<AuditBarTitle title={auditTask?.name} status={auditTask?.status} />
					</Grid>
				</Grid>
			</AppBar>
		</>
	)
}

AuditBar.propTypes = {
	title: PropTypes.string,
}

AuditBar.defaultProps = {
}

export default connect((state) => ({
	auditTask: state.resources.auditTask
}), {})(withStyles(style)(AuditBar));